import { render, staticRenderFns } from "./ColsOrganizer.vue?vue&type=template&id=c389f754"
import script from "./ColsOrganizer.vue?vue&type=script&lang=js"
export * from "./ColsOrganizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports